export const pagination = {
    aria: {
        navLabel: 'Pagination',
        itemLabelPrefix: 'Go to page',
        itemLabelCurrentPrefix: 'Current page, page',
        titlePrevPage: 'previous page',
        titleNextPage: 'next page',
    },
};
//# sourceMappingURL=pagination.js.map